import 'remixicon/fonts/remixicon.css';
import { Link, Route, Switch, useRouteMatch } from 'react-router-dom';
import { Student } from '../../store/viewmodels/StudentViewModel';
import ResultsInfo from './ResultsInfo';

interface TeacherResultsProps {
    students: Student[]
}

function TeacherResults(props: TeacherResultsProps) {
    let { path } = useRouteMatch();

    return (
        <div className="border flex flex-grow w-full">
            <div className="border-r max-w-1/2">
                <ResultsStudentsList students={props.students} path={path + '/'} />
            </div>
            <Switch>
                <Route path={`${path}/:studentId`}>
                    <ResultsInfo />
                </Route>
            </Switch>
        </div>
    );
}

interface ResultsStudentsListProps {
    students: Student[],
    path: string
}

function ResultsStudentsList(props: ResultsStudentsListProps): JSX.Element {

    let items: JSX.Element[] = [];
    items = props.students.map(student => <ResultsStudentListItem key={"resultListItem" + student.id} student={student} path={props.path} />)

    return (
        <div className="bg-white">
            <ul className="divide-y divide-gray-200 border-b">
                {items}
            </ul>
        </div>)
        ;
}

interface ResultsStudentsListItemProps {
    student: Student,
    path: string
}

function ResultsStudentListItem(props: ResultsStudentsListItemProps): JSX.Element {
    const tasks = props.student.task_access_list;
    let stars: JSX.Element[] = [];

    for (let i: number = 0; i < tasks.length; i++) {
        stars.push(<i key={"star"+tasks[i].id} className="ri-star-s-line"></i>)
    }

    let name = props.student.identification === "" ? props.student.username : props.student.identification;
    let group = props.student.group === "" ? "" : "Ryhmä: " + props.student.group ;

    return (
        <li>
            <Link to={props.path + props.student.id} className="block group hover:bg-teal-50">
                <div className="flex items-center px-1 py-1 sm:px-6">
                    <div className="min-w-0 flex-1 flex items-center">
                        <div className="flex-shrink-0">
                            <i className={"text-gray-700 group-hover:text-teal-500 text-3xl ri-star-s-line"}></i>
                        </div>
                        <div className="min-w-0 flex-1 px-4">
                            <p className="text-sm font-medium text-teal-600 truncate">{name}</p>
                            <p className="text-sm font-medium text-teal-600 truncate">{group}</p>
                            <p className="text-sm font-medium text-teal-600 truncate">{stars}</p>
                        </div>
                    </div>
                </div>
            </Link>
        </li>
    );
}

export default TeacherResults;